// extracted by mini-css-extract-plugin
module.exports = {"root":"faq_root__1cG89","inner":"faq_inner__ys990","items":"faq_items__1K2VQ"};